import {useState} from "react";
import AboutDesktopContentLayout from "../components/layouts/aboutScreen/AboutDesktopContentLayout";
import AboutDesktopTabletPageTitleText from "../components/texts/aboutScreen/AboutDesktopTabletPageTitleText";
import AboutContent from "../components/others/aboutScreen/AboutContent";
import AboutDesktopTabBar from "../components/bars/aboutScreen/AboutDesktopTabBar";
import AboutDesktopLayout from "../components/layouts/aboutScreen/AboutDesktopLayout";
import SystemScreenTopBar from "../components/bars/SystemScreenTopBar";
import {useResizeListener} from "../listeners/SystemResizeListener";
import SystemAppDrawer from "../components/others/SystemAppDrawer";
import {useLocation} from "react-router-dom";

export default function AboutScreen() {
    // About Screen used in index.js to display about multiple sections
    // in desktop and tablet modes

    // PROPERTIES
    const location = useLocation();
    const initialTab = location.state?.tab ?? 0;
    const [selectedTab, setSelectedTab] = useState(initialTab);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsDrawerOpen(false))

    // BUILD
    return(
        <div className={"w-full h-[100svh] flex flex-col overflow-hidden bg-backgroundLight3"}>
            {/** MODAL */}
            <SystemAppDrawer open={isDrawerOpen}
                             handleClose={() => setIsDrawerOpen(false)} />
            {/** CONTENT */}
            <SystemScreenTopBar currentTab={null}
                                openDrawer={openDrawer} />
             <AboutDesktopLayout>
                 <AboutDesktopContentLayout>
                     <AboutDesktopTabletPageTitleText />
                     <AboutDesktopTabBar selectedTab={selectedTab}
                                         setSelectedTab={setSelectedTab} />
                     <AboutContent selectedTab={selectedTab}
                                   setSelectedTab={setSelectedTab} />
                 </AboutDesktopContentLayout>
            </AboutDesktopLayout>
        </div>
    );

    // METHODS
    // ---- Open modal
    function openDrawer() {
        setIsDrawerOpen(true)
    }
}